export const DEFAULT_LOGO_PROPS = {
  image: {
    altText: 'Health4Life Parents and Teens logo',
    src: '/images/logo.svg'
  },
  label: 'Return home',
  href: '/',
}